import { FunctionComponent } from "react";

import { useTranslation } from "react-i18next";

interface ExcludeFromListConfirmationProps {
	/** How many leads the action will touch (1 for the per-row variant). */
	count: number;
	/** True when the modal was opened for one lead rather than the selection. */
	single: boolean;
}

/**
 * Body of the "Exclude from list" confirm modal (PREC-4172).
 *
 * The question alone was not enough: the modal said "exclude", the lead then showed under
 * "Unsure" with no reason, and a customer reported the AI sequence generation had moved it. So
 * the modal names where the leads go, that the move is recorded under the user's name, and how
 * to undo it.
 */
export const ExcludeFromListConfirmation: FunctionComponent<ExcludeFromListConfirmationProps> = ({
	count,
	single,
}) => {
	const { t } = useTranslation();

	return (
		<>
			<p data-testid="exclude-from-list-question">
				{single
					? t("inbox.excludeFromListConfirmationMessage")
					: t("inbox.excludeFromListModal.bulkConfirmation", { count })}
			</p>
			<p className="mt-2 text-sm text-text-meta" data-testid="exclude-from-list-consequence">
				{t("inbox.excludeFromListModal.consequence")}
			</p>
		</>
	);
};
